jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  domReady(() => {
    whenGsapReady(() => {
      whenScrollReady(() => {
        initConsultationSection();
      });
    });
  });

  function initConsultationSection() {
    const blocks = document.querySelectorAll(".js-consultation");
    if (!blocks.length) return;

    if (document.body.classList.contains("block-editor-page")) {
      blocks.forEach((block) => {
        block.querySelectorAll(".js-consultation-item").forEach((el) => {
          el.style.opacity = "1";
          el.style.visibility = "visible";
        });
        block.style.setProperty("--cons-offset", "0px");
      });
      return;
    }

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    blocks.forEach((block) => {
      if (block.dataset.consultationInit === "1") return;
      block.dataset.consultationInit = "1";

      const items = Array.from(block.querySelectorAll(".js-consultation-item"));
      const parallaxTarget = block.querySelector(".js-cons-parallax");

      const strengthAttr = block.getAttribute("data-parallax");
      const strength = strengthAttr ? parseFloat(strengthAttr) : 240;

      const speedAttr = block.getAttribute("data-parallax-speed");
      const speed = speedAttr ? parseFloat(speedAttr) : 0.8;
      const factor = clamp(1 - speed, 0, 1);

      const computeOffset = (progress) => {
        const p = clamp(progress, 0, 1);
        const t = (p - 0.5) * 2;
        return -(t * strength * factor);
      };

      const applyOffset = (progress) => {
        if (!parallaxTarget) return;
        const off = computeOffset(progress);
        block.style.setProperty("--cons-offset", `${off}px`);
      };

      if (reduceMotion) {
        if (items.length) {
          gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        }
        block.style.setProperty("--cons-offset", "0px");
        return;
      }

      const stConfig =
        ScrollTrigger &&
        items.length && {
          trigger: block,
          start: "top 76%",
          once: true,
          invalidateOnRefresh: true,
        };

      if (items.length) {
        items.forEach((el) => {
          const fadeOnly = el.classList.contains("js-consultation-item--fade");
          gsap.set(el, fadeOnly ? { autoAlpha: 0 } : { autoAlpha: 0, y: 18 });
        });

        const tl = gsap.timeline(
          stConfig ? { scrollTrigger: stConfig } : undefined,
        );

        items.forEach((el, i) => {
          const at = i * 0.08;
          const fadeOnly = el.classList.contains("js-consultation-item--fade");
          if (fadeOnly) {
            tl.to(
              el,
              {
                autoAlpha: 1,
                duration: 0.9,
                ease: "power3.out",
              },
              at,
            );
          } else {
            tl.to(
              el,
              {
                autoAlpha: 1,
                y: 0,
                duration: 0.9,
                ease: "power3.out",
                clearProps: "transform",
              },
              at,
            );
          }
        });
      }

      if (!parallaxTarget) return;

      if (ScrollTrigger) {
        const st = ScrollTrigger.create({
          trigger: block,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
          onUpdate: (self) => applyOffset(self.progress),
          onRefresh: (self) => applyOffset(self.progress),
        });
        applyOffset(st.progress);
        return;
      }

      let ticking = false;
      const update = () => {
        ticking = false;
        const rect = block.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const total = rect.height + vh;
        const p = clamp((vh - rect.top) / total, 0, 1);
        applyOffset(p);
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);
      update();
    });
  }
});
